import { useTranslation } from "next-i18next";
import PropTypes from "prop-types";
import { titleCase } from "@lib/formatString";
import { ClearIcon } from "@components/Icon";
import { COLOUR_TAGS } from "./constants";
import { useFilter } from "./hooks/useFilter";
import Icon from "../DropDown/Icon";
import styles from "./styles/MenuButton.module.css";

export function MenuButton({ filterName, filterLabels, filteredValues, onClick, onChange }) {
  const { t } = useTranslation("filter");
  const { clearValues } = useFilter({
    filterName,
    filterLabels,
    filteredValues,
    onChange,
  });

  const handleClear = () => {
    clearValues();
  };

  const title = (key) => {
    if (key === COLOUR_TAGS) return t("all-colours-label");
    const translatedKey = t(key);
    return `${t("all-label")} ${titleCase(translatedKey)}s`;
  };

  const trimmedValues = filteredValues.map((value) => value.replace("type:", "").trim());

  const Label = () => {
    const product1 = filteredValues[0] && titleCase(trimmedValues[0]);
    const product2 = filteredValues[1] && titleCase(trimmedValues[1]);

    return (
      <>
        {filteredValues.length > 2 &&
          `${product1}, ${product2}, and ${filteredValues.length - 2} others`}
        {filteredValues.length === 2 && `${product1}, ${product2}`}
        {filteredValues.length === 1 && `${product1}`}
        {filteredValues.length === 0 && "Filters"}
      </>
    );
  };

  return (
    <div className={styles.container}>
      {filteredValues.length > 0 && (
        <button className={styles.clear} onClick={handleClear}>
          <ClearIcon />
        </button>
      )}
      <button className={styles.button} onClick={onClick}>
        {filteredValues.length > 0 ? <Label /> : title(filterName)}
        <Icon icon={"drop-down-arrow"} viewBox="0 0 9 4">
          <path d={"M8.19629 0L4.19629 4L0.196289 0H8.19629Z"} fill="black" />
        </Icon>
      </button>
    </div>
  );
}

MenuButton.propTypes = {
  filterName: PropTypes.string,
  filterLabels: PropTypes.object,
  filteredValues: PropTypes.array,
  onChange: PropTypes.func,
  onClick: PropTypes.func,
};
